import { sendData, sendJson, patchProperty, getJson } from '../../shared/utils/api'
import { asyncActionCreator, clearAsync, valueHolderActionCreator } from '../../shared/redux/actions/common'
import { UPLOAD_PROFILE_PHOTO, EDIT_USER, FETCH_PAYMENT_DETAILS, SET_PAYMENT_STATE, TENANT } from '../const'
import { TagUser } from '../../shared/types/tag'
import { UserRfid } from '../../shared/types/user'

export const uploadProfilePhoto = (photo: File) => {
    return asyncActionCreator(UPLOAD_PROFILE_PHOTO, () => sendData(`users/image`, 'POST', photo))
}

const changeUserErrorCodeMapping = [['0', 'settings.carValidationError'],['1', 'settings.carAlreadyUsed'],['5', 'settings.rfidAlreadyUsed']]

export type UserEditModel = {
    id: string
    firstName: string
    lastName: string
    phone: string
    street: string
    city: string
    country: string
    zip: string
    companyName: string
    companyId: string
    taxId: string
    vatId: string
    cardNumber: string
    cardExpiration: string
    paymentRequestId: string
    tags: TagUser[]
    rfids: UserRfid[]
    cars: any[]
}

export const fetchUser = () => {
    return asyncActionCreator(EDIT_USER, () => getJson('users/me'))
}

export const editUser = (user: UserEditModel) => {
    return asyncActionCreator(EDIT_USER, () => {
        const patchOperations = [
            patchProperty('firstName', user.firstName),
            patchProperty('lastName', user.lastName),
            patchProperty('phone', user.phone),
            patchProperty('street', user.street),
            patchProperty('city', user.city),
            patchProperty('country', user.country),
            patchProperty('zip', user.zip),
            patchProperty('companyName', user.companyName),
            patchProperty('companyId', user.companyId),
            patchProperty('taxId', user.taxId),
            patchProperty('vatId', user.vatId),
            patchProperty('cardNumber', user.cardNumber),
            patchProperty('cardExpiration', user.cardExpiration),
            patchProperty('paymentRequestId', user.paymentRequestId),
        ]
        const payload = {
            operations: patchOperations.filter((op) => op.value !== undefined),
            tags: user.tags,
            rfids: user.rfids,
            cars: user.cars,
        }

        return sendJson(`users/${user.id}`, 'PATCH', payload)
    }, {}, changeUserErrorCodeMapping)
}

export const cardRegister = (userId: String, params: URLSearchParams) => {
    var trustPayWebRegistrationNotification = {
        "UserId": userId,
        "AccountId": params.get('AccountId'),
        "Type": params.get('Type'),
        "Amount": params.get('Amount'),
        "Currency": params.get('Currency'),
        "PaymentRequestId": params.get('PaymentRequestId'),
        "CardId": params.get('CardId'),
        "CardMask": params.get('CardMask'),
        "CardExpiration": params.get('CardExpiration'),
        "AuthNumber": params.get('AuthNumber'),
        "Signature": params.get('Signature'),
        "ResultCode": params.get('ResultCode'),
        "Reference": params.get('Reference'),
    }
    return asyncActionCreator(EDIT_USER, () =>
        sendJson("Pay/cardRegister", "POST", trustPayWebRegistrationNotification)
    )
}

export const clearEditState = () => {
    return clearAsync(EDIT_USER)
}

export const fetchPaymentDetails = (userId: string, amount: string, currency: string, paymentType: number) => {
    const url = `Pay/trustPay?userId=${userId}&amount=${amount}&currency=${currency}&paymentType=${paymentType}`
    return asyncActionCreator(FETCH_PAYMENT_DETAILS, () => getJson(url))
}

export const setPaymentState = (state: number) => {
    return valueHolderActionCreator(SET_PAYMENT_STATE, state)
}

export const clearPaymentState = () => {
    return valueHolderActionCreator(SET_PAYMENT_STATE, null)
}
export const setTenant = (tenant: any) => {
    return valueHolderActionCreator(TENANT, tenant);
  };